import Axios from "axios";
let config = {
  headers: {
    'Access-Control-Allow-Origin': '*',
    "content-type": "application/x-www-form-urlencoded"
  }
};

const url_api = process.env.VUE_APP_API_URL;

export function get(id) {
  return Axios.get(url_api + "/api/transits/" + id, config);
}

export function getAll() {
  return Axios.get(url_api + "/api/transits", config);
}